import React from 'react'
import { useQuery } from '@apollo/client'
import Box from '@material-ui/core/Box'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'
import { useAuth } from 'lib/auth'
import { PageHeader } from 'components/page-header'
import OfferingsPage, {
  OFFERINGS_TAB,
} from 'pages/pga-coach/bookings/offerings'
import OfferingsHeaderActions from 'pages/pga-coach/bookings/offerings/offerings-header-actions'
import useGroupEventsPanel from 'pages/pga-coach/bookings/events/use-group-events-panel'
import GET_COACH_ACCOUNT from 'pages/pga-coach/bookings/query'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    top: theme.mixins.toolbar.minHeight,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    pointerEvents: 'none',
    zIndex: theme.zIndex.modal - 2,
    backgroundColor: theme.palette.background.default,
  },
}))

const CreateEventOfferingsBackdrop = () => {
  const classes = useStyles()
  const { user } = useAuth()
  const groupEventsPanel = useGroupEventsPanel()
  const { data, loading } = useQuery(GET_COACH_ACCOUNT)

  if (loading) {
    return (
      <Box className={classes.root} aria-hidden>
        <LinearProgress color="primary" />
      </Box>
    )
  }

  const hasCoachProfile = data?.currentUser?.attributes?.coachProfile != null
  const activeGroupEvents = data?.currentUser?.groupEvents?.filter(
    event => !event.isCanceled,
  )
  const isOnboardingComplete =
    (activeGroupEvents?.length ?? 0) > 0 || (data?.lessonTypes?.length ?? 0) > 0

  return (
    <Box className={classes.root} aria-hidden>
      <PageHeader
        title="My Offerings"
        tabs={
          <Tabs value={OFFERINGS_TAB.GROUP_EVENTS}>
            <Tab label="Booking Type" />
            <Tab label="Group Events" />
          </Tabs>
        }
        actions={
          <OfferingsHeaderActions
            user={user}
            isOnboardingComplete={isOnboardingComplete}
            isBookingTypeTab={false}
            shouldShowBookingTypeDisclaimer={false}
            onCreateBookingType={() => {}}
            onCreateEvent={() => {}}
            onBookStudentClick={() => {}}
          />
        }
      />
      <OfferingsPage
        selectedTab={OFFERINGS_TAB.GROUP_EVENTS}
        hasCoachProfile={hasCoachProfile}
        setShouldShowBookingTypeDisclaimer={() => {}}
        groupEventsPanel={groupEventsPanel}
      />
    </Box>
  )
}

export default CreateEventOfferingsBackdrop
